(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-card-options')) {
    customElements.define('collection-card-options', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.card = this.closest('.product-card--commerce');
        this.image = this.card.querySelector('.product-card__media img');
        if (this.image) {
          this.original = {
            src: this.image.getAttribute('src'),
            srcset: this.image.getAttribute('srcset'),
            alt: this.image.getAttribute('alt')
          };
        }
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-card-color]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.querySelectorAll('[data-card-color]').forEach((swatch) => {
            swatch.setAttribute('aria-pressed', String(swatch === button));
          });
          this.querySelector('.card-colors__selected').textContent = button.dataset.label;
          if (!this.image) return;
          const selection = button.dataset.image ? {
            src: button.dataset.image,
            srcset: button.dataset.srcset,
            alt: button.dataset.alt
          } : this.original;
          this.image.setAttribute('src', selection.src);
          if (selection.srcset) this.image.setAttribute('srcset', selection.srcset);
          else this.image.removeAttribute('srcset');
          this.image.setAttribute('alt', selection.alt || '');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-conversion-hero"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const shortcut = event.target.closest('[data-collection-filter-shortcut]');
    if (!shortcut) return;
    const section = shortcut.closest('[data-collection-section]');
    if (!section) return;
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const root = section.querySelector(isMobile ? '.facets-drawer' : '.collection-layout__facets');
    if (!root) return;
    const requested = shortcut.dataset.collectionFilterShortcut;
    const facet = [...root.querySelectorAll('.facet')].find((item) => {
      const label = item.querySelector('summary').textContent.toLowerCase();
      return label.includes(requested) || (requested === 'color' && label.includes('colour'));
    });
    if (!facet) return;
    event.preventDefault();
    requestAnimationFrame(() => {
      if (isMobile) root.open = true;
      facet.open = true;
      facet.scrollIntoView({ block: 'nearest' });
      const control = facet.querySelector('input:not(:disabled), summary');
      if (control) control.focus({ preventScroll: true });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const disclosure = event.target.closest('details[data-disclosure]');
    document.querySelectorAll('details[data-disclosure][open]').forEach((item) => {
      if (item !== disclosure && !item.contains(event.target)) item.removeAttribute('open');
    });
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
  });

  document.addEventListener('shopify:section:load', () => {
    document.documentElement.classList.remove('no-js');
  });
  } catch(e) { console.error(e); }
})();

})();
